import {apiConstants, config, requestOptions, requestTypes, sendRequest} from "../../../../Utilities/Api";

class ServerOwnCatalogApi{

    static getOwnCatalogResources(ownSearchCriteria: Record<string, unknown>) {
        const queryParameters = new URLSearchParams(ownSearchCriteria as Record<string, string>).toString();
        return sendRequest(
            requestOptions(config.URL + `own/catalog/?${queryParameters}`,
                requestTypes.GET,
            ),
        );
    }

    static updateOwnCatalogAvailability(ownCatalogItems: Record<string, unknown>[]) {
        return sendRequest(
            requestOptions(config.URL + `own/catalog/`,
                requestTypes.PUT,
                JSON.stringify(ownCatalogItems),
                apiConstants.successMessage.catalog.CATALOG_AVAILABILITY_UPDATED
            ),
        );
    }

    static getShippingLocations()
    {
        return sendRequest(
            requestOptions(config.URL + `shipping-locations`,
                requestTypes.GET,
            ),
        );
    }

    static getWhatsNew() {
        return sendRequest(
            requestOptions(config.URL + `own/catalog/whatsnew`,
                requestTypes.GET,
            ),
        );
    }
}

export const ownCatalogApi = config.environment.MODE === config.modes.SERVER ? ServerOwnCatalogApi : ServerOwnCatalogApi;
